import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import Progress from 'redux-progress';

import VisualAddonPage, { Events } from 'modules/addon/VisualAddonPage';
import {
  selectPageData,
  selectOverviewData,
  isAddToCartEnabled,
} from 'modules/addon/duck/selectors/pageData';
import * as addon from 'modules/addon';
import PageLoading from 'components/common/PageLoading';
import { Dispatch, State } from 'model/State';
import * as marketplace from 'modules/marketplace';
import { fetchAccountOverview } from 'modules/accounts/actions';
import selectIsAuthenticated from 'modules/auth/selectors/isAuthenticated';

type StateProps = addon.model.AddonState & {
  progress: Progress<addon.model.AddonPageData>;
  overviewProgress: Progress<addon.model.OverviewData>;
  isAddToCartEnabled: boolean;
  isAuthenticated: boolean;
};

type DispatchProps = { events: Events };

const AddonPage = (props: StateProps & DispatchProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      props?.progress?.result?.deploymentOption === 'datacenter' ||
      props?.progress?.result?.deploymentOption === 'server'
    ) {
      dispatch(fetchAccountOverview());
    }
  }, [props.progress.inProgress]);

  return (
    <PageLoading progress={props.progress}>
      {(data) => (
        <VisualAddonPage
          {...props}
          data={data}
          overviewProgress={props.overviewProgress}
          isAddToCartEnabled={props.isAddToCartEnabled}
          events={props.events}
          terms={props.terms}
        />
      )}
    </PageLoading>
  );
};

const mapStateToProps = (state: State): StateProps => ({
  ...state.addon,
  progress: selectPageData(state),
  overviewProgress: selectOverviewData(state),
  isAddToCartEnabled: isAddToCartEnabled(state),
  isAuthenticated: selectIsAuthenticated(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  events: {
    onDeploymentChange: (productKey) => dispatch(addon.actions.route(productKey)),
    onModeChange: (mode) => () => dispatch(addon.actions.changeMode(mode)),
    onParentChange: (parent) => dispatch(addon.actions.chooseParent(parent)),
    onTermChange: (key, term) => dispatch(addon.actions.chooseTerm({ key, term })),
    onSearchForAddonsClick: () => dispatch(marketplace.actions.route()),
    onAddToCart: () => dispatch(addon.actions.addToCart()),
    onSenChange: (val) => dispatch(addon.actions.changeSen(val)),
    onEmailChange: (val) => dispatch(addon.actions.changeEmail(val)),
    onSearchSubmit: () => dispatch(addon.actions.search()),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddonPage);
